module.exports = __webpack_public_path__ + "static/media/  (142).ea780458.jpg";